import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import "./Review.css";
import StepForm from "../state-transition/StateTransition";
import {
  updateExamInstitutionReviewFlags,
  updateInstitutionReviewFlags,
  updateReviewFlags,
  updatePayFlag,
  submitInfo,
  setShowLoaderStatus,
  setTotalTranscriptAmount,
  resetPersonalInfoData,
  restExamDetails,
  restInstitutionDetails,
  getTermsAndConditions
} from './../../redux-building-blocks/actions';
import { isEmpty, groupBy } from "lodash";
import { v4 as uuidv4 } from 'uuid';
import Modal from './../shared/modal/Modal';

export class Review extends React.Component {
  constructor(props){
    super(props)
    this.state = {isSubmitClicked:false, overlay: false}
  }

  renderTableRows = (data) => {
    const groupedByExam = groupBy(data, item => item.exam);
  
    return Object.entries(groupedByExam).flatMap(([exam, examGroup]) => {
      const groupedBySeries = groupBy(examGroup, item => `${item.examSeries.month}-${item.examSeries.year}`);
      const totalRowCount = examGroup.length;
  
      let examRendered = false;
  
      return Object.entries(groupedBySeries).flatMap(([seriesKey, seriesGroup]) => {
        return seriesGroup.map((item, index) => {
          const isFirstRowInSeries = index === 0;
          const showExamCell = !examRendered;
  
          if (showExamCell) examRendered = true;
  
          return (
            <tr className="table-row" key={`${item.exam}-${item.examSeries.month}-${item.examSeries.year}-${item.examCenter}`}>
              {isFirstRowInSeries && (
                <td rowSpan={seriesGroup.length} className="table-cell center-cell">
                  {item.examSeries.month} {item.examSeries.year}
                </td>
              )}

              <td className="table-cell">{item.examCenter}</td>

              {showExamCell && (
                <td rowSpan={totalRowCount} className="table-cell center-cell">
                  {item.exam}
                </td>
              )}
            </tr>
          );
        });
      });
    });
  };
  
  
  reDirectToHistory = () =>{
    this.props.resetPersonalInfoData();
    this.props.restExamDetails();
    this.props.restInstitutionDetails();
    this.props.history.push('/transcript-history')
  }

  handleSubmit = () =>{
    this.setState({ overlay: true })
  }
  
  handleContinue = () => {
    console.log('Submitted.')   
    if(!this.state.isSubmitClicked){      
      this.setState({ isSubmitClicked:true });
      this.hideModal();  
      this.props.setShowLoaderStatus(true);       
      const payloadData = { 
        transactionId: this.props.transactionId, 
        transactionStatus: "Not paid" 
      } 
      this.props.submitInfo(payloadData, () => {
        const rate = this.props.transcriptRates?.transcriptsCost?.filter(r=>r.countryCode === 'US'); 
        this.props.setTotalTranscriptAmount(this.props.institutionDetailsList.length * rate[0].amount);
        this.props.updatePayFlag();
        if(isEmpty(this.props.terms)){
          this.props.getTermsAndConditions(uuidv4());        
        }
        this.props.history.push('/acceptTerms'); 
      }); 
    } 
  }

  redirectToEdit = (e,section) => {
    switch(section) {
        case 'Personal':
            this.props.updateExamInstitutionReviewFlags()
            this.props.history.push('/personal-information');
            break;
        case 'Exam':
            this.props.updateInstitutionReviewFlags();
            this.props.history.push('/exam-details');
            break;
        case 'Institution':
            this.props.updateReviewFlags();
            this.props.history.push('/institution-details');
            break;
        default:
      }

  };

  previewOpen = (fileURL) => {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(fileURL);
  }
  else {
      var objectUrl = URL.createObjectURL(fileURL);
      window.open(objectUrl);
  }
  }

  hideModal = () => {
    this.setState({ overlay: !this.state.overlay })
  };

  render() {
    const {examDetailsList,institutionDetailsList,transcriptRates} = this.props;
    examDetailsList.map((item) => {
        return( 
        <div key={item.id} className="sectionLabel pl-3 mb-3 mt-1">
            <p className="font-italic mb-0 font-weight-bold">{item.examSeries.month}  {item.examSeries.year}</p>
            <p className="mb-0">{item.exam}</p>
            <p className="mb-0">{item.examCenter}</p>
        </div>)
      });

      institutionDetailsList.map((item) => {
        return( 
        <div key={item.id} className="sectionLabel pl-3 mb-3 mt-1">
            <p className="font-italic mb-0 font-weight-bold">{item.institute.split(',')[0]}</p>
            <p className="mb-0">{item.StreetRoadName}</p>
            <p className="mb-0">{item.CityTownName}, {item.CountyRegionName} {item.PostCode}</p>
        </div>)
      });

       institutionDetailsList.map((item,i) => {        
        const rate = transcriptRates?.transcriptsCost?.filter(r=>r.countryCode === 'US');        
        if(!isEmpty(rate)){           
          return(         
          <div key={item.id} className="sectionLabel pl-3">
              <p className="mb-0">{item.institute.split(',')[0]}  ${rate[0].amount.toFixed(2)} {rate[0].currency}</p>
              {i === this.props.institutionDetailsList.length-1 ?  <p className="mb-0">Total charge: ${(institutionDetailsList.length * rate[0].amount)?.toFixed(2)} {rate[0].currency}</p>:''}
          </div>);
          }         
          return null;
        });
    

    
    return (
      <React.Fragment>
        <div className="w-100">
        <StepForm pathname={this.props.location.pathname}></StepForm>
          <label className ="h3Size mb-0.6"><b>Review and confirm</b>
          </label>
              <div className="card mt-2">  
                  <div className="card-body">
                        <div>
                            <div className="sectionLabel font-weight-bold"><span>Personal information</span><span id="personalRedirectToEdit" className="ml-2 cursor" onClick={(e) => this.redirectToEdit(e,'Personal')}><FontAwesomeIcon icon={faPen}/> Edit</span></div>
                                <div className="sectionLabel pl-3 mb-3 mt-1">
                                    <p className="font-italic mb-0 font-weight-bold">{this.props.PersonalInfoFromSAPCDC.firstName}  {this.props.PersonalInfoFromSAPCDC.lastName}</p>
                                    <p className="mb-0">{this.props.PersonalInfoFromSAPCDC.email}</p>
                                    <p className="mb-0">{this.props.PersonalInfoLocal.fileName}&nbsp;&nbsp;<span className="preview" id="testPreview" onClick={(e) => this.previewOpen(this.props.PersonalInfoLocal.file)}><u>Preview</u></span></p>
                                </div>
                        </div>
                        
                        <div>
                            <div className="sectionLabel font-weight-bold"><span >Exam details</span><span className="ml-2 cursor" id="examRedirectToEdit" onClick={(e) => this.redirectToEdit(e,'Exam')}><FontAwesomeIcon icon={faPen}/> Edit</span></div>  
                            <div>Transcripts will be sent from the following center(s) and series:</div>
                            <div>&nbsp;</div>
                             </div>
                              <div>
                                <table className="table">
                                <thead>
                                  <tr>
                                    <th className="table-cell col-one">Series</th>
                                    <th className="table-cell col-two">Center(s)</th>
                                    <th className="table-cell col-three">Exam</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.renderTableRows(examDetailsList, 'exam')}
                                </tbody>
                              </table>
                              </div>
                        
                        <div>      
                            <div className="sectionLabel font-weight-bold"><span >Institution details</span><span className="ml-2 cursor" id="instituteRedirectToEdit" onClick={(e)=>this.redirectToEdit(e,'Institution')}><FontAwesomeIcon icon={faPen}/> Edit</span></div>
                            <div>Transcripts will be sent to the following institutions:</div>
                            <div>&nbsp;</div> 
                            <div>
                            <table className="table">
                              <thead>
                                <tr>
                                  <th className="table-cell col-one">Institution details</th>
                                  <th className="table-cell col-two">Fee</th>
                                  <th className="table-cell col-three">Total Charge</th>
                                </tr>
                              </thead>
                              <tbody>
                                {institutionDetailsList.map((item, i) => {
                                  const rate = transcriptRates?.transcriptsCost?.find(r => r.countryCode === 'US');
                                  return rate ? (
                                    <tr key={item.id} className="table-cell">
                                      <td className="table-cell">{item.institute.split(',')[0]}
                                      <tr>{item.StreetRoadName} </tr>
                                      <tr>{item.CityTownName} {item.CountyRegionName} {item.PostCode}</tr></td>
                                      <td className="table-cell center-cell">${rate.amount.toFixed(2)} {rate.currency}</td>
                                      {i === 0 ? (
                                        <td className="table-cell center-cell" rowSpan={institutionDetailsList.length}>
                                          ${(
                                            institutionDetailsList.length *
                                            rate.amount
                                          )?.toFixed(2)} {rate.currency}
                                        </td>
                                      ) : null}
                                    </tr>
                                  ) : null;
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                    </div>
              </div>
        
        <div className="mt-3 mb-3">
            <button disabled={this.state.isSubmitClicked ? true:false} type="button" className="btn font-weight-bold save-button-review text-white pl-2 pr-2 mr-3" id="submitInfoButton" onClick={(event) => this.handleSubmit(event)}>
             Confirm
            </button>            
            <button onClick={this.reDirectToHistory} type="button" className="btn btn-link font-weight-bold mt-1 text-decoration-none"><span>Cancel</span></button>
            
        </div>
        <div><p className="confirm-warning">After you click “Confirm” this request cannot be changed. You will have 48 hours to submit payment.</p></div>
        </div>
        <div id='printModalContent'>                
          <Modal show={this.state.overlay} hideModal={this.hideModal} rec='review' mobile={this.props.mobileDevice} handleContinue={this.handleContinue} />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    PersonalInfoFromSAPCDC : state.currentUser.profile,
    transactionId: state.commonData.transactionId,
    PersonalInfoLocal : state.personalInfo,
    examDetailsList : state.examDetailsInfo.examDetailsList,
    institutionDetailsList : state.institutesDetailsInfo.institutesDetailList,
    transcriptRates : state.reviewConfirm,
    terms : state.termsAndConditionsReducer.conditionsApiText,
    mobileDevice: state.commonData.mobileDevice
  };
};

const mapDispachToProps =  {
  updateExamInstitutionReviewFlags,
  updateInstitutionReviewFlags,
  updateReviewFlags,
  updatePayFlag,
  submitInfo,
  setShowLoaderStatus,
  setTotalTranscriptAmount,
  resetPersonalInfoData,
  restExamDetails,
  restInstitutionDetails,
  getTermsAndConditions
};
export default withRouter(connect(
  mapStateToProps,mapDispachToProps
)(Review));
